import { render, staticRenderFns } from "./SliderInStock.vue?vue&type=template&id=496c2041"
import script from "./SliderInStock.vue?vue&type=script&lang=js"
export * from "./SliderInStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports